import * as React from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Switch, TextField, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import {clonePrCampaign} from "./portalRedirectCampaignsService";
import PrConfirmDialog from "./prConfirmDialog";

type Props = {
    row: any | null;
    onClose: () => void;
    onSaved: () => void;
};

export default function PrCloneModal({row, onClose, onSaved}: Props) {
    const [form, setForm] = React.useState<any>(null);
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [saving, setSaving] = React.useState(false);

    React.useEffect(() => {
        if (!row) {
            setForm(null);
            setConfirmOpen(false);
            setSaving(false);
            return;
        }
        setForm({
            hpCampaignId: "",
            hpCampaignIdLb: "",
            dailyCap: row.dailyCap,
            monthlyCap: row.monthlyCap,
            activeFlag: false,
            isBranded: !!row.isBranded,
        });
    }, [row]);

    if (!row || !form) {
        return null;
    }

    const save = async () => {
        setSaving(true);
        const lb = form.hpCampaignIdLb === "" ? null : Number(form.hpCampaignIdLb);
        const ok = await clonePrCampaign({
            portalRedirectId: row.id,
            hpCampaignId: Number(form.hpCampaignId),
            hpCampaignIdLb: lb,
            dailyCap: Number(form.dailyCap),
            monthlyCap: Number(form.monthlyCap),
            activeFlag: !!form.activeFlag,
            isBranded: !!form.isBranded,
        });
        if (ok) {
            toast.success(`${form.hpCampaignId} created successfully.`);
            setConfirmOpen(false);
            onSaved();
        }
        setSaving(false);
    };

    return (
        <>
        <Dialog open={!!row} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Clone Campaign</DialogTitle>
            <DialogContent>
                <Typography sx={{mb: 2}}><b>{row.brokerName} &gt; {row.schoolName} - {row.appId}</b></Typography>
                <Box sx={{display: "flex", gap: 1, mb: 1}}>
                    <TextField fullWidth label="New Campaign Id" type="number" value={form.hpCampaignId} onChange={(e) => setForm({...form, hpCampaignId: e.target.value})}/>
                    <TextField fullWidth label="New LB Campaign Id" type="number" value={form.hpCampaignIdLb} onChange={(e) => setForm({...form, hpCampaignIdLb: e.target.value})}/>
                </Box>
                <Box sx={{display: "flex", gap: 1, mb: 1}}>
                    <TextField fullWidth label="Daily Cap" type="number" value={form.dailyCap} onChange={(e) => setForm({...form, dailyCap: e.target.value})}/>
                    <TextField fullWidth label="Monthly Cap" type="number" value={form.monthlyCap} onChange={(e) => setForm({...form, monthlyCap: e.target.value})}/>
                </Box>
                <FormControlLabel control={<Switch checked={!!form.activeFlag} onChange={(e) => setForm({...form, activeFlag: e.target.checked})}/>} label="Active"/>
                <FormControlLabel control={<Switch checked={!!form.isBranded} onChange={(e) => setForm({...form, isBranded: e.target.checked})}/>} label="Branded"/>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={() => setConfirmOpen(true)}>Clone</Button>
            </DialogActions>
        </Dialog>
            <PrConfirmDialog
                open={confirmOpen}
                message="Are you sure you want to clone this campaign?"
                loading={saving}
                onClose={() => { if (!saving) setConfirmOpen(false); }}
                onConfirm={save}
            />
        </>
    );
}
